import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { BaseComponent } from 'src/app/base/base.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginByRe } from 'src/app/model/login-re';

declare var $: any;
@Component({
  selector: 'app-login-re-modal',
  templateUrl: './login-re-modal.component.html',
  styleUrls: ['./login-re-modal.component.scss'],
})
export class LoginReModalComponent
  extends BaseComponent
  implements AfterViewInit
{
  @ViewChild('loginForm', { static: true }) loginForm!: NgForm;
  @Output() loginReEvent = new EventEmitter<LoginByRe>();

  isFormValid: boolean = false;
  isForeign: boolean = false;

  rhAreas: string[] = [ "AO01", "AR02", "BO01", "CO01", "CO02", "CO03", "CR01", "EC01", "EC21", "EQ01", "EQ02", "GT01", "IC01", "IE01", "LG01", "MA01", "MA02", "MF01", "MF02", "MF03", "MI01", "MI02", "MX01", "MZ02", "PA01", "PE01", "PE02", "PS01", "PS04", "PY01", "QS01", "UN02", "UN04", "UN08", "UN11", "UN12", "UN13", "UN14", "UN15", "UN16", "UN17", "UNER", "US02", "VE01", "VE03" ];

  constructor(
    public router: Router,
    public translate: TranslateService,
    private location: Location,
  ) {
    super(router, translate);
  }

  ngAfterViewInit(): void {
    this.loginForm.statusChanges?.subscribe((status) => {
      this.isFormValid = status === 'VALID';
    });

    $('#modalLoginRE').on('hidden.bs.modal', () => {
      this.goBack();
    });

    this.loginForm.valueChanges?.subscribe((value) => {
      this.isForeign = value.isForeign;
    });
  }

  goBack() {
    this.location.back();
  }

  onSubmit() {
    if (this.loginForm.form.valid) {
      this.loginReEvent.emit(this.loginForm.form.value);
    }
  }
}
